import invariant from 'tiny-invariant';
import { useListContext } from '../list-context';
export function useListDivider() {
  const size = useListContext(ctx => {
    invariant(ctx !== null, "<ListDivider /> can't be used outside of <List/> component");
    return ctx.size;
  });
  return {
    size
  };
}